import React from 'react';

const About = () => {
  return (
    <div style={{padding:"20px"}}>
      <h2>About ChatGPT Voice powered Assistant</h2>
      <p>ChatGPT Voice powered Assistant, a project that I'm deeply passionate about! The purpose of this application is to simplify daily task management and boost productivity for users in both their personal and professional lives.</p>
      <h3>My Inspiration</h3>
      <p>I started this project because I noticed that many people struggle with organizing their tasks effectively. As someone who enjoys developing efficient solutions, I saw a need for a user-friendly task management application that could streamline workflows and help individuals stay on top of their responsibilities.</p>
      <h3>My Vision</h3>
      <p>My vision for this project is to become the go-to task management tool for individuals, students, professionals, and teams alike. I envision users relying on our application to organize their lives efficiently, reduce stress, and achieve their goals with ease.</p>
      <p>If you have any questions, suggestions, or just want to say hello, feel free to reach out. I'd love to hear from you!</p>
      
      <li>Email:  <a href="mamidalaharinath96@gmail.com" target="_blank" style={{overflowWrap:"break-word"}}>mamidalaharinath96@gmail.com</a></li>
      <li>LinkedIn: <a href="https://www.linkedin.com/in/harinath-mamidala/" target="_blank" style={{overflowWrap:"break-word"}}>https://www.linkedin.com/in/harinath-mamidala/</a></li>
      <li>GitHub: <a href="https://github.com/mamidalaharinat1" target="_blank" style={{overflowWrap:"break-word"}}>https://github.com/mamidalaharinat1</a></li>
      
    </div>
  );
};

export default About;
